// router/visibility-helpers.ts
import type { RouteLocationNormalized, RouteRecordNormalized } from 'vue-router'
import type { Visibility } from './RouteMeta'

/** Résout la visibilité d'un record individuel (valeur ou fonction) */
export function resolveRouteRecordVisibility(record: RouteRecordNormalized): Visibility {
  const visibility = record.meta?.visibility
  if (typeof visibility === 'function') {
    // La fonction a accès aux stores réactifs (auth, contexte, etc.)
    return visibility(record as any)
  }
  return (visibility ?? 'visible') as Visibility
}

/** Calcule la visibilité "effective" de la navigation cible :
 *  - si un parent est hidden → hidden
 *  - sinon si un parent est disabled → disabled
 *  - sinon visible
 */
export function resolveEffectiveVisibility(targetRoute: RouteLocationNormalized): Visibility {
  let effective: Visibility = 'visible'
  for (const matchedRecord of targetRoute.matched) {
    const recordVisibility = resolveRouteRecordVisibility(matchedRecord)
    if (recordVisibility === 'hidden') return 'hidden'
    if (recordVisibility === 'disabled') effective = 'disabled'
  }
  return effective
}
